
<div class="container mt-1">
  <div class="card shadow-sm">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-0">Checker Approval</h4>
        
      </div>
      <button class="btn btn-secondary btn-sm" (click)="back()">Back</button>
    </div>
    <div class="card-body">
      <form>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Employee ID</label>
          <!-- <select class="form-select" [(ngModel)]="itfacilityreject_data.employeeid" name="employeeId" (change)="Onselectempolyee()">
            <option value="">Select Employee</option>
            <option *ngFor="let emp of employeeid" [value]="emp.OD_EmployeeID">{{ emp.OD_EmployeeID }}</option>
          </select> -->
        
          <input class="form-control" [(ngModel)]="itfacilityreject_data.IR_EmployeeId" name="OD_EmployeeID" />
        
        </div>
        
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Full Name</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.IR_Fullname" name="lastName" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">AD User Name</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.IR_ADUserName" name="IR_ADUserName" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Mail ID</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.IR_ADMailId" name="IR_ADMailId" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Designation</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.IR_Designation" name="IR_Designation" type="text" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">location</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.IR_Grade" name="IR_Grade" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Department</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.IR_Department" name="IR_Department" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Assert Type</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.IR_AssertType" name="IR_AssertType" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">NAS Drive Access</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.IR_NacDriver_Access" name="IR_NacDriver_Access" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Dongle & Sim Card</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.IR_Dongle_SimCard" name="IR_Dongle_SimCard" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Mobile & Sim Card</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.IR_Mobilesim" name="IR_Mobilesim" />
        </div>
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">BioMetric Access Card</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.IR_Biometric_card" name="IR_Biometric_card" />
        </div>
         <!--<div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Door Access</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.IR_DoorAccess" name="IR_DoorAccess" />
        </div>-->
         <div class="mb-3 d-flex align-items-center">
          <label class="form-label me-3" style="width: 150px;">Other</label>
          <input class="form-control" [(ngModel)]="itfacilityreject_data.IR_Other" name="Other" /><!--*ngIf="appservice.editchecker==='rejected'"-->
        </div>
        <!--<div class="mb-3 d-flex align-items-center" >
  <label class="form-label me-3" style="width: 150px;">Comments</label>
  <textarea
  class="form-control"
  [(ngModel)]="itfacilityreject_data.command"
  name="command"
  style="height: 50px;"
  placeholder="Reason">
</textarea>

</div>-->

        <div class="action-buttons d-flex justify-content-start gap-2 mt-3">
           <button class="btn btn-approve" type="button" (click)="onApprove()" >Approve</button>
          <button class="btn btn-decline" type="button" (click)="onDecline()">Decline</button>
        </div>
      </form>
    </div>
  </div>
</div>
